"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrder = void 0;
const updateOrder = async (supabase, order) => {
    delete order.reference; //generated column can't be used
    delete order.client;
    delete order.created_by_user;
    delete order.order_lines;
    delete order.transactions;
    delete order.agent;
    delete order.payment_methods;
    delete order.payment_requests;
    const { data, error } = await supabase.from("orders").upsert(order).single();
    if (error) {
        console.log("error", error);
        throw new Error(error.message);
    }
    return data;
};
exports.updateOrder = updateOrder;
